import { motion } from "framer-motion";
import { memo, useMemo } from "react";
import IconButton from "../components/IconButton.tsx";
import Modal from "../feedback/Modal.tsx";
import { getFileType } from "../utils/validators.ts";
import "./data-display.css";

interface ModalImageProps {
	image?: string;
	onClose: () => void;
	isOpen: boolean;
}

function ModalImage({ image, onClose, isOpen }: ModalImageProps) {
	const isImage = useMemo(() => {
		return image && ["image", "blob"].includes(getFileType(image));
	}, [image]);
	
	const isPdf = useMemo(() => {
		return image && getFileType(image) === "pdf";
	}, [image]);

	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<motion.div
				className="modal-image-content"
				initial={{ scale: 0.8 }}
				animate={{ scale: 1 }}
				exit={{ scale: 0.8 }}
				onClick={(e) => e.stopPropagation()}
			>
				{isImage && (
					<motion.img
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						transition={{ duration: 0.3 }}
						src={image}
						alt="Modal Preview"
					/>
				)}
				{isPdf && (
					<embed
						src={image}
						type="application/pdf"
						style={{ minWidth: "800px", minHeight: "800px" }}
					/>
				)}
				<div style={{ position: "absolute", top: 10, right: 10 }}>
					<IconButton
						icon="X"
						size="lg"
						onClick={onClose}
						backgroundColor="#00000080"
						hoverColor="#ffffff80"
					/>
				</div>
			</motion.div>
		</Modal>
	);
}

export default memo(ModalImage);
